export default "__VITE_ASSET__CpsFOAiW__"